import { render, staticRenderFns } from "./login.vue?vue&type=template&id=478c786a&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=478c786a&prod&rel=stylesheet%2Fless&lang=less"
import style1 from "./login.vue?vue&type=style&index=1&id=478c786a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c786a",
  null
  
)

export default component.exports